import { FlagValuesMap } from '@/core/flags/flags.state';
import { SPONSORED_FEATURES_FLAGS } from '@/productDiscovery/SponsoredProducts/constant';

export interface SponsoredFlags {
  sp1: boolean;
  sp2: boolean;
  sp3: boolean;
  rerank: boolean;
}

export const processSponsoredFlags = (
  sponsoredFlagsArray: boolean[],
): SponsoredFlags => {
  const sp1 = sponsoredFlagsArray[0];
  const sp2 = sponsoredFlagsArray[1];
  const sp3 = sponsoredFlagsArray[2];
  const rerank = sponsoredFlagsArray[3];

  return {
    sp1,
    sp2,
    sp3,
    rerank,
  };
};

export const getSponsoredFlagsValues = (
  flags: FlagValuesMap,
): SponsoredFlags => {
  const sp1 = Boolean(flags[SPONSORED_FEATURES_FLAGS[0]]);
  const sp2 = Boolean(flags[SPONSORED_FEATURES_FLAGS[1]]);
  const sp3 = Boolean(flags[SPONSORED_FEATURES_FLAGS[2]]);
  const rerank = Boolean(flags[SPONSORED_FEATURES_FLAGS[3]]);

  return {
    sp1,
    sp2,
    sp3,
    rerank,
  };
};

export const getAbtParameter = (sponsoredFlags: SponsoredFlags) => {
  const abt =
    (sponsoredFlags.sp1 ? 'b' : 'a') +
    (sponsoredFlags.sp2 ? 'b' : 'a') +
    (sponsoredFlags.sp3 ? 'b' : 'a') +
    '|' +
    (sponsoredFlags.rerank ? 'b' : 'a');
  return abt;
};

export const getAbtParameterFromSaga = (flags: FlagValuesMap) => {
  const flagsValues = getSponsoredFlagsValues(flags);
  return getAbtParameter(flagsValues);
};

export const getAbtParameterFromHook = (sponsoredFlagsArray: boolean[]) => {
  const flagsValues = processSponsoredFlags(sponsoredFlagsArray);
  return getAbtParameter(flagsValues);
};
